var map = {
	"./image_33.png": "f247",
	"./odysee.png": "907e",
	"./promo.png": "0ce4",
	"./savedVideo.png": "5c5a",
	"./savedVideoIcon.png": "0ab3",
	"./video1.png": "79d8",
	"./video2.png": "9849",
	"./video3.png": "e458"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";